import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment.prod';
import { BaseAPIClass } from '../class/baseAPI.class';
// import { BaseAPIClass } from '..';
import { Paginated } from '../model/paginated.model';

@Injectable({
  providedIn: 'root'
})
export class PaginaService extends BaseAPIClass {

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = '/paginas';
  }

  getListarPaginas(categoria:any, cantidad:number): Observable<any> {

    return this.httpClient.get(this.baseUrl + '/categoria?categoria='+ categoria +'& cantidad='+ cantidad )
  }

  getListarPaginasHabilitados(id:any): Observable<any> {

    return this.httpClient.get(this.baseUrl + '/habilitados/'+ id );
  }

  getListarPaginasMenuHabilitados(id:any): Observable<any> {

    return this.httpClient.get(this.baseUrl + '/menu/'+ id );
  }

  getListarPaginasIndex(term:any, categoria_id:any): Observable<any> {

    return this.httpClient.get(this.baseUrl + '?term='+ term +'& categoria_id='+ categoria_id )
  }

  enabledMenu(id: any) {
    return this.httpClient
      .get(this.baseUrl + '/esmenu/'+ id)
      .pipe(
        map((body: any) => {
          return body;
        })
      );
  }



}
